export const formIds = ['details', 'transactions', 'files'] as const;

export const ids = [...formIds, 'pre-processing'] as const;
